import { Component, input, inject, PLATFORM_ID, AfterViewInit, ViewContainerRef, EnvironmentInjector, createComponent } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-client-odometer',
  standalone: true,
  imports: [CommonModule, DecimalPipe],  // Still NO TmNgOdometerModule here
  template: `
    <ng-container *ngIf="isBrowser; else static">
      <ng-container #odometerHost></ng-container>  <!-- Anchor for dynamic component -->
    </ng-container>

    <ng-template #static>
      {{ number() | number:'1.2-2' }}
    </ng-template>
  `,
})
export class ClientOdometerComponent implements AfterViewInit {
  number = input.required<number>();
  config = input<any>({
    animation: 'slide',
    format: '(,ddd).dd',
    theme: 'default',
    auto: true
  });

  private platformId = inject(PLATFORM_ID);
  isBrowser = isPlatformBrowser(this.platformId);

  private vcr = inject(ViewContainerRef);
  private envInjector = inject(EnvironmentInjector);

  private componentRef: any = null;

  async ngAfterViewInit() {
    if (!this.isBrowser) return;

    try {
      // Dynamic import of the module/component ONLY on browser
      const { TmNgOdometerComponent } = await import('odometer-ngx');

      // Modern way: createComponent directly with the Type
      this.componentRef = createComponent(TmNgOdometerComponent, {
        environmentInjector: this.envInjector,
        hostElement: this.vcr.element.nativeElement,  // or leave undefined for automatic insertion
      });

      // Attach to view container (if not using hostElement)
      this.vcr.insert(this.componentRef.hostView);

      // Pass inputs
      this.componentRef.instance.number = this.number();
      this.componentRef.instance.config = this.config();

      // Trigger change detection
      this.componentRef.changeDetectorRef.detectChanges();
    } catch (err) {
      console.error('Failed to dynamically load odometer:', err);
    }
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
}